import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export default function Input({
  label,
  error,
  className = "",
  ...props
}: InputProps) {
  return (
    <div className="flex flex-col gap-1 w-full">
      {label && (
        <label className="text-sm font-medium text-gray-700">{label}</label>
      )}

      <input
        {...props}
        className={`
          w-full h-[50px] rounded-[10px] border p-5 font-[500] text-sm outline-none
          focus:ring-1 focus:ring-black focus:border-black
          disabled:bg-gray-100 disabled:text-gray-400
          ${error ? "border-red-500 focus:ring-red-500 focus:border-red-500" : "border-[#e6e6e6]"}
          ${className}
        `}
      />

      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}
